import React from 'react';
import { render } from 'react-dom';
import 'normalize.css';
import { GlobalStyles } from './global-styles';
import { App } from './app';

// Create a demo user for testing
const demoUsers = [
  {
    firstName: 'Demo User',
    email: 'demo@test.com',
    password: 'password',
    photoURL: 1,
  },
];

// Initialize demo users if not exists
if (!localStorage.getItem('users')) {
  localStorage.setItem('users', JSON.stringify(demoUsers));
}

render(
  <React.StrictMode>
    <GlobalStyles />
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
